export const environment = {
  production: false,
  test: false,
  dev: true,
  envSuffix: ' ┃ DEV',
  redirectUri: 'https://karrara.dev.sla03.devtest.aws.scania.com',
  remotes: {
    outbound: 'outbound',
    inbound: 'inbound',
  },
  authUrl: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
  clientId: '373456ae-4bf1-4d6c-a7b3-ad75223ab642',
  tenantId: '3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',

  // protectedResource: 'kdex-lite-api.dev.sla03.devtest.aws.scania.com',
  urlApiKarraraOutbound: 'https://karrara-out-api.dev.sla-outbound-kd.devtest.gf.aws.scania.com/',
  urlApiKarraraInbound: 'https://karrara-in-api.dev.sla-inbound.devtest.gf.aws.scania.com/',
};
